/**
 * @description Global - Front Only
 */

(() => {
  /**
   *@description Animation au chargement de la page
   */
  const loader = () => {
    const item = document.querySelector("[data-js-loader]") || null;
    item ? (item.className += " hidden") : "";
  };
  // GO après chargement 🚀
  window.addEventListener("load", () => {
    loader();
  });
})();
